import { getAllUserPending, getAllUserSuccess, getAllUserFail } from "./allUserSlice";
import { fetchAllUser } from "../../../api/userApi";

export const getAllUser = () => async(dispatch) => {
    try {
         //call the api
        dispatch(getAllUserPending());
        const result = await fetchAllUser();
        //const userData=JSON.parse(result);
        const myJSON = JSON.stringify(result);
        
//console.log('alluserData '+myJSON);
//console.log('alluserData 1  '+myJSON.user);
const myObj =JSON.parse(myJSON);
const userdetails =JSON.parse(JSON.stringify(myObj.user));
const userdetails1 =JSON.parse(JSON.stringify(userdetails));
//console.log('us '+userdetails1['id']);
//console.log('getuserpending '+result.user[0].firstName);
/* console.log('getuserpending user '+result.user[0].firstName);
console.log('getuserpending fname '+result.lastName);
console.log('getuserpending lname '+result.user.lastName); */
//console.log('check user profile out if');
        if(userdetails){
        //console.log('check user profile');
            return dispatch(getAllUserSuccess(userdetails));
        }
        dispatch(getAllUserFail("User is not found"));

       
    } catch (error) {
        console.log(error)
        dispatch(getAllUserFail(error));

    }
}